import {
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import commonActions from "../Redux/common/actions";
import { auditLog } from "../utils/auditLog";
import useFetchCandidateTokenDetails from "../hooks/useFetchCandidateTokenDetails";

export default function NotificationModal() {
  const dispatch = useDispatch();
   const { heartBeat } = useSelector(
      (state) => state.examReducer
    );
  const { showModal } = useSelector((state) => state.commonReducer);
  const [candidateTokenDetails, setCandidateTokenDetails] = useState(null);
  useFetchCandidateTokenDetails({ setCandidateTokenDetails });

  const handleClose = () => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: false, type: null, method: "N", data: null },
    });
      auditLog({
        data: {
          RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
          RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
          Activity: "User closed Exam Started Popup",
          IPaddress: "",
        },
        dispatch,
        heartBeat,
      });
  };

  return (
    <>
      <Dialog
        open={showModal?.show && showModal?.method === "N"}
        onClose={handleClose}
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "12px",
            padding: "8px",
            backgroundColor: "rgba(240, 240, 251, 1)",
          },
        }}
      >
        <DialogContent
          sx={{
            width: "100%",
            backgroundColor: "rgba(240, 240, 251, 1)",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              color: "#000",
            }}
          >
            <IoMdCloseCircleOutline />
          </IconButton>
          <Typography sx={{ fontSize: 32, textAlign: "center" }}>
            Exam has started
          </Typography>
        </DialogContent>
      </Dialog>
    </>
  );
}
